import { GuidanceScreen } from "@/components/guidance/GuidanceScreen";

export function GuidancePage() {
  return <GuidanceScreen />;
}
